import React, { useState, useEffect, memo } from "react";
import { useTable, useGlobalFilter, usePagination } from "react-table";
import { ValidatorForm } from "react-form-validator-core";
import SelectValidator from "../../partial/SelectValidator";
import { getUserDetail, getUserTypeOptions } from "../../../utils";
import { decrypt } from "../../../utils/encodingdecoding";
import { getAllCustomer } from "../../../services/services";

const Paginated2 = memo(({ data, tableColumns, loader, setLoader, selectedUserType, setSelectedUserType, setData, setResponse, setSelectedUserNumber, selectedUserNumber, fetchSchema, searchValue, setSearchValue, initialLoad, setInitialLoad }) => {

    const [selectPage, setSelectPage] = useState();
    const [selectedPageIndex, setSelectedPageIndex] = useState(1);
    const [pageArray, setPageArray] = useState();
    const [customerCount, setCustomerCount] = useState();

    const { getTableProps, getTableBodyProps, rows, headerGroups, page, nextPage, state, setPageSize, prepareRow, setGlobalFilter } = useTable(
        {
            columns: tableColumns,
            data,
            manualPagination: true,
            pageCount: selectPage,
            initialState: { pageSize: 50 },
        },
        useGlobalFilter,
        usePagination
    );
    const { globalFilter, pageSize } = state;
    const [inputField, setInputField] = useState(globalFilter); //eslint-disable-line
    const options = [
        // { label: "Select All", value: "" },
        ...getUserTypeOptions(decrypt(localStorage.getItem("Id")))
    ];

    useEffect(() => {
        setGlobalFilter(inputField);
    }, [inputField]); //eslint-disable-line

    useEffect(() => {
        if (customerCount !== undefined && customerCount !== null) {
            const totalPages = Math.ceil(customerCount / pageSize);
            setSelectPage(totalPages);
        } else {
            setSelectPage(0);
        }
    }, [customerCount, pageSize]);

    useEffect(() => {
        setPageArray(
            selectPage > 0
                ? Array.from({ length: selectPage }, (_, i) => i + 1)
                : []
        );
    }, [selectPage]);

    useEffect(() => {
        setInitialLoad(false)
    }, [searchValue, selectedUserNumber, selectedUserType])

    const fetch = async (pageNo = 1) => {
        try {
            setLoader(true);
            const token = JSON.parse(localStorage.getItem("token_gen"));
            const res = await getAllCustomer(
                token?.access_token,
                "customer",
                true,
                "Customers",
                selectedUserNumber,
                searchValue,
                "customerType",
                selectedUserType,
                pageNo,
                pageSize
            );
            if (res.message === "Success") {
                setCustomerCount(res?.totalCount)
                setResponse(res?.data)
            }
        } catch (err) { }
        finally { setLoader(false) }

    };

    const handlePageIndex = (event) => {
        const pageNo = Number(event.target.value);
        setSelectedPageIndex(pageNo);
        fetch(pageNo);
    };

    const handleNext = () => {
        if (selectedPageIndex < pageArray?.length) {
            const nextPageNo = selectedPageIndex + 1;
            setSelectedPageIndex(nextPageNo);
            fetch(nextPageNo);
        }
    };

    const handlePrevious = () => {
        if (selectedPageIndex > 1) {
            const prevPageNo = selectedPageIndex - 1;
            setSelectedPageIndex(prevPageNo);
            fetch(prevPageNo);
        }
    };

    const handleSubmit = async () => {
        setSelectedPageIndex(1);

        setInitialLoad(true);
        await fetchSchema();

        fetch(1);
    };

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="customTable">
                <div className="customTable__header">
                    <div className="customTable__left">
                        <div className="customTable__showingRecords">
                        </div>
                    </div>
                    <div className="customTable__right">
                        <div className="d-flex gap-2 align-items-center">
                            <ValidatorForm onSubmit={handleSubmit}>
                                <div className="d-flex gap-2">
                                    <div style={{ minWidth: "220px" }}>
                                        <SelectValidator
                                            placeholder="Select"
                                            className="custom-ReactSelect bordered"
                                            name="type"
                                            value={getUserDetail.find((item) => item.value === selectedUserNumber)}
                                            selected={selectedUserNumber}
                                            options={getUserDetail}
                                            onChange={(option) => {
                                                setSelectedUserNumber(option.value);
                                                setData([]);
                                            }}
                                        />
                                    </div>
                                    <div className="customTable__searchFilter">
                                        <label>Mobile:</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            value={searchValue || ""}
                                            maxLength={10}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*$/.test(value)) {
                                                    setSearchValue(value);
                                                }
                                            }}
                                        />
                                    </div>
                                    <div style={{ minWidth: "220px" }}>
                                        <SelectValidator
                                            placeholder="Select"
                                            className="custom-ReactSelect bordered"
                                            name="type"
                                            value={options.find((item) => item.value === selectedUserType)}
                                            selected={selectedUserType}
                                            options={options}
                                            onChange={(option) => {
                                                setSelectedUserType(option.value);
                                                setData([]);
                                            }}
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-primary" disabled={searchValue?.length !== 10 || !selectedUserNumber || !selectedUserType}>
                                        Search
                                    </button>
                                </div>
                            </ValidatorForm>
                        </div>
                    </div>
                </div>
                <div className="customTable__body">
                    <div className="table-responsive">
                        {data?.length ? (
                            <>
                                <p>Displaying {selectedUserType} details for {selectedUserNumber === "distMobile" ? "distributor number" : "sales number"} linked to mobile {searchValue}.</p>
                                <table className="table table-striped table-bordered sticky_table" {...getTableProps()}>
                                    <thead>
                                        {headerGroups.map((headerGroup) => (
                                            <tr {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map((column) => (
                                                    <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                                                ))}
                                            </tr>
                                        ))}
                                    </thead>

                                    <tbody {...getTableBodyProps()}>
                                        {page.map((row, rowIndex) => {
                                            prepareRow(row);
                                            return (
                                                <tr {...row.getRowProps()} key={rowIndex}>
                                                    {row.cells.map((cell) => (
                                                        <td {...cell.getCellProps()}>
                                                            {cell.render("Cell") || "Null"}
                                                        </td>
                                                    ))}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </>
                        ) : (
                            initialLoad &&
                            <table className="table table-striped table-bordered" {...getTableProps()}>
                                <thead>
                                    {headerGroups.map((headerGroup) => (
                                        <tr {...headerGroup.getHeaderGroupProps()}>
                                            {headerGroup.headers.map((column) => (
                                                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                                            ))}
                                        </tr>
                                    ))}
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan={headerGroups?.[0]?.headers?.length}>
                                            <p style={{ textAlign: "center", margin: 0 }}>No data found</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
                {rows.length ? <div className="customTable__footer">
                    <div className="customTable__left">
                        <div className="customTable__totalTransactions">
                            <p>
                                Total Customers: <span>{rows.length}</span>
                            </p>
                        </div>
                    </div>
                    <div className="customTable__right">
                        <div className="customTable__top">
                            <div className="customTable__totalPages">
                                {pageArray && (
                                    <p>
                                        Page
                                        <select className="form-control selectArrow" value={selectedPageIndex} onChange={handlePageIndex}>
                                            {pageArray?.length ? (
                                                pageArray.map((value) => (
                                                    <option key={value} value={value}>
                                                        {value}
                                                    </option>
                                                ))
                                            ) : (
                                                <option key={1} value={1}>
                                                    {1}
                                                </option>
                                            )}
                                        </select>
                                        of{pageArray?.length ? (
                                            <span>{pageArray?.length}</span>) : <span>{1}</span>}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="customTable__bottom customTable__bottom__2">
                            <div className="customTable__buttons">
                                <span className="btn btn-outline-primary" onClick={() => handlePrevious()} disabled={selectedPageIndex > 1 ? false : true}>
                                    {"Previous"}
                                </span>
                                <span className="btn btn-outline-primary" onClick={handleNext} disabled={pageArray?.length > 0 ? (selectedPageIndex === pageArray?.length ? true : false) : true}>
                                    {"Next"}
                                </span>
                            </div>
                        </div>
                    </div>
                </div> : ""}
            </div>
        </>
    );
});

export default Paginated2
